import { useMutation, useQuery } from "react-query";
import { baseUrl } from "./api";
import { CapacitorHttpAuth } from "./auth";
import { Journey } from "../types/api/journey.types";

export const createJourney = async ({
  mainVehicleId,
  driverId,
  trailerId,
}: {
  mainVehicleId: string;
  driverId: string;
  trailerId?: string;
}) => {
  let response = await CapacitorHttpAuth({
    url: `${baseUrl}/driver/journey`,
    method: "POST",
    data: {
      mainVehicleId,
      driverId,
      trailerId,
    },
  });
  if (response.data) {
    return response.data as Journey;
  }
  return;
};

export const patchJourneyFinalize = async ({ id }: { id: string }) => {
  let response = await CapacitorHttpAuth({
    url: `${baseUrl}/driver/journey/${id}/finalize`,
    method: "PATCH",
  });
  if (response.data) {
    return response.data as Journey;
  }
  return;
};

export const useGetCurrentJourneyQuery = () => {
  return useQuery({
    queryKey: ["getCurrentJourney"],
    queryFn: async () => {
      let response = await CapacitorHttpAuth({
        url: `${baseUrl}/driver/current-journey`,
        method: "GET",
      });
      if (response.data) {
        return response.data as Journey;
      }
    },
  });
};
